//@ts-ignore
import { createEffect, createSignal, onCleanup, For, onMount, createMemo } from "solid-js";
import { View, Text, hexColor, Show, ElementNode } from "@lightningtv/solid";
import { useNavigate, useParams } from "@solidjs/router";
import styles from "../../styles";
import {
  isVpnMode,
  playListPassword,
  playListUrl,
  playListUsername,
  setGlobalBackground,
  setIsPlaying,
  setIsVpnMode,
  setPreviewToNotShow,
} from "../../../state";
import { Button, ButtonContainer, Column, Input, Keyboard, Row } from "@lightningtv/solid-ui";
import axios from "axios";
import { assertTruthy } from "@lightningjs/renderer/utils";
import { createInfiniteScroll } from "../../components/pagination";
import searchMovies from "../../api/providers/searchMovies";
import { LazyUp } from "@lightningtv/solid/primitives";
import searchLive from "../../api/providers/searchLive";
import LoadingIndicator from "../loading/loading";
import videoPlayer from "../../video";

// Fixed layout to match other search pages
const layout = [
  ["A", "B", "C", "D", "E", "F"],     // 0
  ["G", "H", "I", "J", "K", "L"],     // 1
  ["M", "N", "O", "P", "Q", "R"],     // 2
  ["S", "T", "U", "V", "W", "X"],     // 3
  ["Y", "Z", "1", "2", "3", "4"],     // 4
  ["5", "6", "7", "8", "9", "0"]      // 5
];

const SearchLive = () => {
  const refs: Array<Array<any>> = layout.map(() => []);
  const [inputValue, setInputValue] = createSignal("");
  const [isLoading, setIsLoading] = createSignal(true); // Add loading state
  const [hasError, setHasError] = createSignal(false); // Add error state
  let lastFocusedKey = refs[0][0];

  let spaceRef: any, backspaceRef: any, searchRef: any;

  const params = useParams();
  const navigate = useNavigate();

  onMount(() => {
    // Only set focus if not loading and no error
    if (!isLoading() && !hasError()) {
      refs[0][0]?.setFocus?.();
    }
  });

  ////// Search////////////////////////////////////////////
  const [data2, setData2] = createSignal(null);
  const [data, setData] = createSignal(null);

  ////// Search////////////////////////////////////////////
  const providerCategory = createMemo(() => {
    return createInfiniteScroll(
      //@ts-ignore
      searchLive(params.filter || "all"),
    );
  });

  createEffect(() => {
    try {
      setIsLoading(true);
      setHasError(false); // Reset error state

      const kevi: any = providerCategory().pages();
      if (providerCategory().pages()) {
        //@ts-ignore
        setData(kevi);
        setIsLoading(false);
        setHasError(false);

        // Set focus to first key after loading is complete
        setTimeout(() => {
          refs[0][0]?.setFocus?.();
        }, 100);
      }
    } catch (error) {
      console.error("Error loading live channels data:", error);
      setIsLoading(false);
      setHasError(true);
    }
  });

  onMount(() => {
    setGlobalBackground("#0A1C34");
    const storedData = localStorage.getItem("moviesData");
    if (storedData) {
      setData2(JSON.parse(storedData));
    }
  });

  ///Search////////////////////////////////////////
  createEffect(() => {
    localStorage.setItem("searchInput", inputValue());
  });

  onMount(() => {
    const storedInput = localStorage.getItem("searchInput");
    if (storedInput) {
      setInputValue(storedInput);
    }
  });

  const [displayedItems, setDisplayedItems] = createSignal([]);

  const filterData = () => {
    if (!inputValue()) return providerCategory().pages();
    return providerCategory()
      .pages()
      .filter((item: any) => item.title.toLowerCase().includes(inputValue().toLowerCase()));
  };

  // Create an effect to update the displayed items whenever `filterData` changes
  createEffect(() => {
    if (videoPlayer) {
      videoPlayer.destroy();
    }
    const filtered: any = filterData();
    setDisplayedItems([]); // Reset list
    setTimeout(() => setDisplayedItems(filtered), 0); // Update list with new data
  });

  let viewRef;
  let row1;

  const titleSignal = createSignal("");
  const keyEvent = createSignal("");
  const [resetLazyUp, setResetLazyUp] = createSignal(false);

  createEffect(() => {
    titleSignal[0](); // React to search input changes
    setResetLazyUp(false); // Remove the component
    setTimeout(() => setResetLazyUp(true), 0); // Re-add the component in the next tick
  });

  // Helper function to handle keypad interactions - disabled when loading or error
  const handleKeypadInteraction = (callback: () => void) => {
    if (!isLoading() && !hasError()) {
      callback();
    }
  };

  return (
    <View color={hexColor("#182027")}>
      <View
        width={1920}
        onEscape={() => {
          if (!isLoading()) {
            navigate(-1);
          }
        }}
        height={1700}
        positionAbsolute={0}
        src={"https://i.ibb.co/Lzk5hD4Y/Maskgroup.png"}
      >
        <View src="https://i.ibb.co/ZVmDwNg/logo.png" x={800} y={50} width={270} height={82} />

        <View x={50} y={50}>
          <View src="https://i.ibb.co/LX13T2JW/Group-Live-Tv.png" width={102} height={102} />
          <Text x={120} y={33} fontSize={34} fontWeight={"bold"}>Search</Text>
        </View>

        <View x={1600} y={50}>
          <View
            onEnter={() => {
              handleKeypadInteraction(() => navigate("/userInfo"));
            }}
            onDown={() => {
              handleKeypadInteraction(() => backspaceRef.setFocus());
            }}
            ref={searchRef}
            x={120}
            style={{
              width: 100,
              height: 100,
              opacity: isLoading() || hasError() ? 0.3 : 1 // Visual feedback when disabled
            }}
            forwardStates style={styles.searchSettingsButton}
          >
            <View x={28} y={28} src="https://i.ibb.co/Jjp8bmn4/setting.png" width={42} height={42} style={{ color: "#ffffff", focus: { color: "#000000" } }} />
          </View>
        </View>

        {/* Loading Overlay */}
        <Show when={isLoading()}>
          <View
            width={1920}
            height={1700}
            color={hexColor("#000000")}
            alpha={0.7}
            positionAbsolute={0}
            style={{ zIndex: 1000 }}
          >
            <View x={960} y={500}>
              <LoadingIndicator isCategoriesIndicator={false} />
            </View>
          </View>
        </Show>

        {/* Error Overlay */}
        <Show when={hasError()}>
          <View
            width={1920}
            height={1700}
            color={hexColor("#000000")}
            alpha={0.8}
            positionAbsolute={0}
            style={{ zIndex: 1000 }}
          >
            <View x={1160} y={300} style={{ textAlign: 'center' }}>
              {/* Error Icon */}
              <View x={-50} y={0} width={100} height={100}>
                <Text fontSize={80} color={hexColor("#FF6B6B")}>⚠️</Text>
              </View>

              {/* Error Message */}
              <Text
                x={-300}
                y={120}
                fontSize={42}
                color={hexColor("#FFFFFF")}
                fontWeight="bold"
                style={{ textAlign: 'center' }}
              >
                There is a problem at the moment
              </Text>
              <Text
                x={-150}
                y={180}
                fontSize={32}
                color={hexColor("#CCCCCC")}
                style={{ textAlign: 'center' }}
              >
                Please try again later
              </Text>


            </View>
          </View>
        </Show>

        <View style={{ opacity: isLoading() || hasError() ? 0.3 : 1 }}>
          {/* Input Text Display */}
          <View x={100} y={220} style={styles.containerText}>
            <Text fontSize={48} x={20} y={15}>{inputValue()}</Text>
          </View>

          {/* Space Key */}
          <View
            ref={(el) => (spaceRef = el)}
            x={100}
            y={310}
            forwardStates style={styles.searchSpace}
            onEnter={() => handleKeypadInteraction(() => setInputValue(prev => prev + " "))}
            onDown={() => handleKeypadInteraction(() => refs[0][0]?.setFocus())}
            onRight={() => handleKeypadInteraction(() => backspaceRef.setFocus())}
            onUp={() => handleKeypadInteraction(() => searchRef.setFocus())}
          >
            <View src={"https://i.ibb.co/G4SDmcq9/space.png"} width={100} height={80} x={80} style={{ color: "#ffffff", focus: { color: "#000000" } }} />
          </View>

          {/* Backspace Key */}
          <View
            ref={(el) => (backspaceRef = el)}
            x={360}
            y={310}
            forwardStates style={styles.searchSpace}
            onEnter={() => handleKeypadInteraction(() => setInputValue(prev => prev.slice(0, -1)))}
            onDown={() => handleKeypadInteraction(() => refs[0][0]?.setFocus())}
            onLeft={() => handleKeypadInteraction(() => spaceRef.setFocus())}
            onUp={() => handleKeypadInteraction(() => searchRef.setFocus())}
          >
            <View src={"https://i.ibb.co/wh6n5N3X/backspace.png"} width={70} height={60} y={10} x={100} style={{ color: "#ffffff", focus: { color: "#000000" } }} />
          </View>

          {/* Character Keys */}
          <View x={100} y={400}>
            {layout.map((row, rowIndex) => (
              <View y={rowIndex * 85}>
                {row.map((char, colIndex) => (
                  <View
                    ref={(el) => {
                      refs[rowIndex][colIndex] = el;
                      el.onFocus = () => {
                        if (!isLoading() && !hasError()) {
                          lastFocusedKey = el;
                        }
                      };
                    }}
                    forwardStates style={styles.buttonKey}
                    x={colIndex * 85}
                    onEnter={() => handleKeypadInteraction(() => setInputValue(prev => prev + char))}
                    onRight={() => {
                      handleKeypadInteraction(() => {
                        const next = refs[rowIndex][colIndex + 1];
                        if (next) {
                          next.setFocus();
                        } else {
                          viewRef?.setFocus();
                        }
                      });
                    }}
                    onLeft={() => {
                      handleKeypadInteraction(() => {
                        const prev = refs[rowIndex][colIndex - 1];
                        if (prev) prev.setFocus();
                      });
                    }}
                    onDown={() => {
                      handleKeypadInteraction(() => {
                        const down = refs[rowIndex + 1]?.[colIndex];
                        if (down) down.setFocus();
                      });
                    }}
                    onUp={() => {
                      handleKeypadInteraction(() => {
                        if (rowIndex === 0) {
                          spaceRef?.setFocus();
                        } else {
                          const up = refs[rowIndex - 1]?.[colIndex];
                          if (up) up.setFocus();
                        }
                      });
                    }}
                  >
                    <Text fontSize={40} x={25} y={25} style={{ color: "#ffffff", focus: { color: "#000000" } }}>{char}</Text>
                  </View>
                ))}
              </View>
            ))}
          </View>
        </View>

        <Text fontSize={38} x={700} y={230}>Channels</Text>

        <View clipping y={100} x={700} gap={20}>
          <Show
            when={!isLoading() && !hasError() && providerCategory().pages().length > 0}
            fallback={
              <Show when={!isLoading() && !hasError()}>
                <Text x={1350} fontSize={30}>No channels found</Text>
              </Show>
            }
          >
            <Show when={resetLazyUp()}>
              {/* @ts-ignore */}
              <LazyUp
                y={200}
                component={Row}
                onLeft={() => handleKeypadInteraction(() => lastFocusedKey?.setFocus())}
                ref={viewRef}
                direction="row"
                upCount={8}
                each={displayedItems()}
                selected={0}
              >
                {(item: any) => {
                  const encodedUrl = btoa(item().image_stream);
                  return (
                    <View
                      onEnter={() => {
                        handleKeypadInteraction(() => {
                          setPreviewToNotShow(false);
                          navigate(`/livetv?num=${item().stream_id}&isTrue=true`);
                        });
                      }}
                      x={950}
                      style={{
                        borderRadius: 15,
                        border: { width: 0, color: hexColor("#45617a") },
                        color: hexColor("#484e55"),
                        focus: { color: hexColor("#ffffff") },
                        transition: {
                          scale: { duration: 250, easing: "ease-in-out" },
                        },
                        height: 200,
                        width: 220,
                        justifyContent: "flexStart",
                        alignItems: "flexStart",
                      }}
                    >
                      <View
                        src={
                          item().image_stream
                            ? `https://proxy1.orbixplay.com/${encodedUrl}`
                            : "./assets/television.png"
                        }
                        x={30}
                        y={10}
                        style={{ width: 150, height: 100, borderRadius: 10 }}
                      ></View>
                      <Text style={{ ...styles.textchannels, color: hexColor("#ffffff"), focus: { color: hexColor("#000000") } }} x={20} y={155}>
                        {item().title.length > 25 ? `${item().title.slice(0, 25)}...` : item().title}
                      </Text>
                    </View>
                  )
                }}
              </LazyUp>
            </Show>
          </Show>
        </View>
      </View>
    </View>
  );
};

export default SearchLive;